if (!customElements.get("accordion-wrapper")) {
  class Accordion extends HTMLElement {
    constructor() {
      super();
      this.options = this.dataset.options;
      this.items = this.querySelectorAll(".accordion__item");
      this.onlyOneActive = false;
    }

    connectedCallback() {
      this.listenerController = new AbortController();
      this.bindEvents();
    }

    disconnectedCallback() {
      this.listenerController.abort();
    }

    bindEvents() {
      let t = this;
      const signal = this.listenerController.signal;
      this.items.forEach(function (item) {
        let toggle = item.querySelector(".accordion__toggle");
        if(toggle){
          toggle.addEventListener("click", function (event) {
            event.preventDefault();
            t.toggle(item.dataset.item);
          }, { signal });
          if(item.dataset.open){
            t.toggle(item.dataset.item);
          }
        }

        let toggleNext = item.querySelector(".accordion__toggle-next");
        if(toggleNext) {
          toggleNext.addEventListener("click", function (event) {
            event.preventDefault(),
            t.toggle(parseInt(item.dataset.item) + 1);
          }, { signal })
        }
      });
    }
        
    toggle(currentItem) {
      let t = this;
      this.items.forEach(function (item) {
        const content = item.querySelector(".accordion__content");
        if(!content) return;
        if(item.dataset.item == currentItem) {
          if(item.classList.contains('is-active')) {
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          }
          item.classList.toggle("is-active");
        } else if(t.onlyOneActive) {
          item.classList.remove("is-active");
          content.style.maxHeight = null;
        }
      });
    }
  }

  customElements.define('accordion-wrapper', Accordion);
}